module.exports = __webpack_public_path__ + "img/close_white.53b12ccc.svg";